export default __webpack_public_path__ + "static/media/gray_trash.1b6f3896.svg";